/**
 * お気に入りリスト（Wishlist Club）の文言を英語にする（英語市場のみ読み込む）
 *
 * Wishlist Club は今のプランでは1言語しか設定できないため、アプリの文言は日本語にし、
 * 英語市場ではこのファイルで英語に置き換える。layout/theme.liquid で markets == 'en' のときだけ読み込む。
 *
 * - 対象は Wishlist Club が描画した部分だけ（APP_SELECTOR）。テーマの他の部分には触れない。
 * - 文言が完全に一致したときだけ置き換える。アプリの設定（ウィッシュリストのスタイリング → 言語）で
 *   日本語を変えたときは、下の TEXTS の日本語も同じに直すこと。
 * - アプリは画面を後から描くので、DOM の変化を監視して追加された部分も置き換える。
 */
(function () {
  // アプリの文言キー: [日本語（アプリに設定した文言）, 英語]
  var TEXTS = {
    // 商品ページ・コレクションのボタン
    wishlistBeforeButtonText: ['お気に入りに追加', 'Add to Wishlist'],
    wishlistAfterButtonText: ['お気に入りに追加済み', 'Added to Wishlist'],
    notifyMeButtonText: ['入荷通知を受け取る', 'Notify me'],

    // 入荷通知フォーム
    notifyMeFormTitle: ['入荷通知の受け取り方法', 'Notify me via:'],
    descriptionHelperText: ['メールアドレスを入力すると、入荷したときにお知らせします。', 'Leave us your e-mail and we will let you know as soon as it is available!'],
    variantLabelText: ['種類', 'Variant'],
    emailLabelText: ['メールアドレス', 'Email'],
    emailInputPlaceHolderText: ['メールアドレスを入力', 'Email Address...'],
    emailValidationMessage: ['メールアドレスの形式が正しくありません。', 'Your email address is not valid.'],
    phoneValidationMessage: ['電話番号の形式が正しくありません。', 'Your phone number is not valid'],
    submitButtonText: ['入荷したら知らせる', 'Notify Me When Available'],
    successMessage: ['入荷したらお知らせします。', 'We will notify you when the item is available'],
    alreadySubscribeMessage: ['この商品の入荷通知は登録済みです。', 'You already have subscribed for this item'],
    emailVerificationMessage: ['確認メールを送りました。メール内のリンクから確認してください。', 'We have sent verification mail to your email. Please verify your email.'],

    // お気に入り一覧ページ
    wishlistPageTitle: ['お気に入り', 'My Wishlist'],
    defaultWishlistTitle: ['お気に入りリスト', 'My Wishlist'],
    encouragingUserToRegister: ['お気に入りを保存して、ほかのスマホやパソコンでも見るには', 'To save your wishlist and see it on other devices, please'],
    loginButtonText: ['ログイン', 'login'],
    textForOr: ['または', 'or'],
    registrationButtonText: ['会員登録', 'sign up'],
    noProductMessage: ['お気に入りに登録した商品はありません', 'There is no product in your wishlist!'],
    addToCartButtonText: ['カートに入れる', 'Add to Cart'],
    removeProductText: ['お気に入りから削除', 'Remove Product'],
    addToCartAllButtonText: ['すべてカートに入れる', 'Add all to cart'],
    soldOutItemText: ['売り切れ', 'Sold Out'],
    shareSectionHeadingText: ['共有する', 'Share on'],
    wishlistSharingText: ['お気に入りリストを見てね', 'Check my wishlist'],
    recommendationTitle: ['おすすめの商品', 'You may also like'],
    editWishlistButtonText: ['リストを編集', 'Edit Wishlist'],
    deleteWishlistButtonText: ['リストを削除', 'Delete Wishlist'],
    wishlistCreateDropdownText: ['新しいリストを作る', 'Create another Wish List'],
    saveForLaterText: ['あとで買う', 'Save for later'],
    clearCartWarningMessage: ['カートの商品をすべて削除して、お気に入りの商品をすべてカートに入れますか？', 'Do you want to remove all existing items from your cart and add all wishlist products?'],

    // リストの作成・名前の変更・削除のダイアログ
    createWishlistModelTitle: ['お気に入りリストを作る', 'Create Wishlist List'],
    createWishlistModelDescriptionText: ['リストに商品を保存しておけます。共有しない限り、リストはご本人だけが見られます。', 'Use lists to save items for later. All lists are private unless you share them with others.'],
    createWishlistModelLabelText: ['リスト名', 'List name'],
    createWishlistModelPlaceHolderText: ['リスト名を入力', 'Create Wishlist List'],
    createWishlistModelSaveBtnText: ['作成する', 'Create List'],
    createWishlistModelCancelBtnText: ['キャンセル', 'Cancel'],
    updateWishlistModelTitle: ['リスト名を変更', 'Update your wishlist name'],
    updateWishlistModelUpdateBtnText: ['変更する', 'Update List'],
    deleteWishlistModelTitle: ['削除しますか？', 'Are You Sure?'],
    deleteWishlistModelDescriptionText: ['このリストを削除します。よろしいですか？', 'Are you sure you want to delete this?'],
    deleteWishlistModelDeleteBtnText: ['削除する', 'Delete'],
    cartRemoveModelTitle: ['この商品をあとで買うリストに保存しますか？', 'Save this item for later'],
    cartRemoveSaveButtonText: ['保存する', 'Save for later'],
    cartRemoveModelNoButtonText: ['保存しない', 'No thanks'],

    // 画面上部に出るメッセージ
    addedToWishlistMessage: ['お気に入りに追加しました', 'Product added to Wishlist'],
    removedFromWishlistMessage: ['お気に入りから削除しました', 'Product removed from wishlist'],
    addedToCartMessage: ['カートに追加しました', 'Product added to cart'],
    addToCartErrorTitle: ['エラーが発生しました', 'There is an Error!!!'],
    addToCartErrorMessage: ['カートに追加できませんでした。お手数ですがお問い合わせください。', 'Product is not added to cart, please contact us.'],
    removedFromSaveForLaterOnCartMessage: ['あとで買うリストから商品を削除しました', 'Product removed from save for later successfully'],
    deleteWishlistModelSuccessMessage: ['あとで買うリストに保存しました', 'Successfully saved for later'],
    saveForLaterRemoveMessage: ['あとで買うリストから削除しました', 'Item removed from Saved for Later'],
    wishlistCreateMessage: ['リストを作成しました', 'Wishlist created successfully'],
    wishlistRemoveMessage: ['リストを削除しました', 'Wishlist removed successfully'],
    wishlistRenameMessage: ['リスト名を変更しました', 'Wishlist renamed successfully']
  };

  // Wishlist Club が描画する要素（ボタン・一覧ページ・ダイアログ・入荷通知・メッセージ）
  var APP_SELECTOR = [
    '.th_prd_wl_btn', '.th_wl_col_btn', '.wc_wishlistBlock', '.wc_wl_bis_btn',
    '.WishlistClubContainer', '.WishlistClubContain', '.WishlistClubSaveForLater',
    '.wcWishlistModal', '[class*="wcBis"]', '.wcAlertBox', '.wishlistClubShare',
    '.wc_suggested_header', '.wcProductCard'
  ].join(',');
  var ATTRIBUTES = ['placeholder', 'aria-label', 'title'];

  var map = {};
  Object.keys(TEXTS).forEach(function (key) {
    map[TEXTS[key][0]] = TEXTS[key][1];
  });

  function translate(value) {
    var trimmed = value.trim();
    if (!trimmed || !Object.prototype.hasOwnProperty.call(map, trimmed)) return null;
    return value.replace(trimmed, map[trimmed]);
  }

  function translateElement(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var text = translate(node.nodeValue);
      if (text !== null) node.nodeValue = text;
    }
    var elements = [root].concat(Array.prototype.slice.call(root.querySelectorAll('[placeholder], [aria-label], [title]')));
    elements.forEach(function (el) {
      ATTRIBUTES.forEach(function (attr) {
        if (!el.hasAttribute(attr)) return;
        var value = translate(el.getAttribute(attr));
        if (value !== null) el.setAttribute(attr, value);
      });
    });
  }

  function translateWithin(node) {
    var el = node.nodeType === 1 ? node : node.parentElement;
    if (!el) return;
    var app = el.closest(APP_SELECTOR);
    if (app) {
      translateElement(app);
      return;
    }
    Array.prototype.forEach.call(el.querySelectorAll(APP_SELECTOR), translateElement);
  }

  function start() {
    translateWithin(document.body);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          translateWithin(mutation.target);
        } else {
          Array.prototype.forEach.call(mutation.addedNodes, translateWithin);
        }
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
